export default __webpack_public_path__ + "static/media/nextjs.99104094.png";